export function StatusPill({ value }) {
  return <span className={`status-pill status-${value}`} data-testid={`status-pill-${value}`}>{value.replaceAll("_", " ")}</span>;
}

export function Modal({ title, onClose, children, testId }) {
  return (
    <div className="admin-modal-backdrop" onClick={onClose} data-testid={testId}>
      <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal-head">
          <h3>{title}</h3>
          <button className="admin-icon-btn" onClick={onClose} data-testid="modal-close-button" aria-label="Close">×</button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function Pager({ page, total, pageSize, onPage }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (pages <= 1) return null;
  return (
    <div className="admin-pager" data-testid="pager">
      <button disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid="pager-prev">← Prev</button>
      <span>{page} / {pages}</span>
      <button disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid="pager-next">Next →</button>
    </div>
  );
}

export function Toolbar({ search, onSearch, status, onStatus, statuses, placeholder, children }) {
  return (
    <div className="admin-toolbar">
      <input value={search} onChange={(e) => onSearch(e.target.value)} placeholder={placeholder || "Search…"}
        data-testid="toolbar-search" />
      {statuses && (
        <select value={status} onChange={(e) => onStatus(e.target.value)} data-testid="toolbar-status-filter">
          <option value="">All statuses</option>
          {statuses.map((s) => <option key={s} value={s}>{s.replaceAll("_", " ")}</option>)}
        </select>
      )}
      {children}
    </div>
  );
}
